<itfg-kyc [client]="client"></itfg-kyc>